var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    stroke: "#868686",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.75,
    y: 4.06708,
    width: 16.5,
    height: 3.66667,
    rx: 1.83333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.58301 7.7337V16.9004C4.58301 17.9129 5.40382 18.7337 6.41634 18.7337H15.583C16.5955 18.7337 17.4163 17.9129 17.4163 16.9004V7.7337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M9.16699 11.4004H12.8337"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.001a8ac9b0e309d974253b4614be97af.svg";
export { ForwardRef as ReactComponent };